import type { ReleaseResource, GitReference } from "@octopusdeploy/octopus-server-client";
import { HasGitPersistenceSettings } from "@octopusdeploy/octopus-server-client";
import type React from "react";
import { getCommitLink } from "~/areas/projects/components/Releases/gitHostLinkGenerator";
import { useOptionalProjectContext } from "~/areas/projects/context";
import Section from "~/components/Section";
import { FormSectionHeading, Note } from "~/components/form";
import { GitRefLink } from "../GitRefLink/GitRefLink";
const ProcessSnapshot: React.FC<{
    vcsRef: GitReference;
    commitUrl: string | null;
}> = ({ vcsRef, commitUrl }) => (<>
        When this release was created, a snapshot of the deployment process was taken from <GitRefLink gitRef={vcsRef} commitUrl={commitUrl}/>
    </>);
ProcessSnapshot.displayName = "ProcessSnapshot"
export const ProcessSnapshotFormSection: React.FC<{
    release: ReleaseResource;
}> = ({ release }) => {
    const projectContext = useOptionalProjectContext();
    if (!projectContext?.state.model) {
        return null;
    }
    const project = projectContext.state.model;
    if (!(project.IsVersionControlled && release && release.VersionControlReference)) {
        return null;
    }
    const commitUrl = HasGitPersistenceSettings(project.PersistenceSettings) ? getCommitLink(project.PersistenceSettings.Url, release.VersionControlReference.GitCommit) : null;
    return (<>
            <FormSectionHeading title="Process Snapshot"/>
            <Section>
                <Note>
                    <ProcessSnapshot vcsRef={release.VersionControlReference} commitUrl={commitUrl}/>
                </Note>
            </Section>
        </>);
};
ProcessSnapshotFormSection.displayName = "ProcessSnapshotFormSection"
